{
  "AccountSettings_accountHeading": [
    {
      "type": 0,
      "value": "Account"
    }
  ],
  "AccountSettings_addressLabel": [
    {
      "type": 0,
      "value": "Home address"
    }
  ],
  "AccountSettings_authentication_biometricLabel": [
    {
      "type": 0,
      "value": "Fingerprint or Face unlock"
    }
  ],
  "AccountSettings_authentication_faceLabel": [
    {
      "type": 0,
      "value": "Face unlock"
    }
  ],
  "AccountSettings_authentication_fingerprintLabel": [
    {
      "type": 0,
      "value": "Fingerprint unlock"
    }
  ],
  "AccountSettings_authentication_irisLabel": [
    {
      "type": 0,
      "value": "Iris unlock"
    }
  ],
  "AccountSettings_authentication_pinLabel": [
    {
      "type": 0,
      "value": "PIN unlock"
    }
  ],
  "AccountSettings_cancelButton": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "AccountSettings_confirmPasswordLabel": [
    {
      "type": 0,
      "value": "Confirm new password"
    }
  ],
  "AccountSettings_contactHeading": [
    {
      "type": 0,
      "value": "Contact information"
    }
  ],
  "AccountSettings_currentPasswordLabel": [
    {
      "type": 0,
      "value": "Current password"
    }
  ],
  "AccountSettings_editButton": [
    {
      "type": 0,
      "value": "Edit"
    }
  ],
  "AccountSettings_editHeading": [
    {
      "type": 0,
      "value": "Edit account settings"
    }
  ],
  "AccountSettings_email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "AccountSettings_emailLabel": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "AccountSettings_familyNameLabel": [
    {
      "type": 0,
      "value": "Last name"
    }
  ],
  "AccountSettings_givenNameLabel": [
    {
      "type": 0,
      "value": "First name"
    }
  ],
  "AccountSettings_heading": [
    {
      "type": 0,
      "value": "Account"
    }
  ],
  "AccountSettings_instructionsForUseLink": [
    {
      "type": 0,
      "value": "Instructions for use"
    }
  ],
  "AccountSettings_investigationalDevice": [
    {
      "type": 0,
      "value": "CAUTION—Investigational device. Limited by Federal law to investigational use."
    }
  ],
  "AccountSettings_investigationalDeviceVersion": [
    {
      "type": 0,
      "value": "Version: "
    },
    {
      "type": 1,
      "value": "version"
    }
  ],
  "AccountSettings_legalHeading": [
    {
      "type": 0,
      "value": "Legal"
    }
  ],
  "AccountSettings_logOutLink": [
    {
      "type": 0,
      "value": "Log out"
    }
  ],
  "AccountSettings_nameLabel": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "AccountSettings_newPasswordLabel": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "AccountSettings_notificationsHeading": [
    {
      "type": 0,
      "value": "Notification settings"
    }
  ],
  "AccountSettings_passwordHeading": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "AccountSettings_phoneLabel": [
    {
      "type": 0,
      "value": "Phone number"
    }
  ],
  "AccountSettings_phonePlaceholder": [
    {
      "type": 0,
      "value": "Phone number"
    }
  ],
  "AccountSettings_pushNotificationsLabel": [
    {
      "type": 0,
      "value": "Allow push notifications"
    }
  ],
  "AccountSettings_termsOfServiceLink": [
    {
      "type": 0,
      "value": "Terms of service & privacy policy"
    }
  ],
  "AccountSettings_unknownValue": [
    {
      "type": 0,
      "value": "Unknown"
    }
  ],
  "Account_connectedHeading": [
    {
      "type": 0,
      "value": "Connected"
    }
  ],
  "Account_patientLabel": [
    {
      "type": 0,
      "value": "Patient"
    }
  ],
  "Account_patientRelationHeading": [
    {
      "type": 0,
      "value": "Your relation"
    }
  ],
  "Account_patientRelationLabel": [
    {
      "type": 0,
      "value": "Relation"
    }
  ],
  "ActionTodoItem_activityAdd": [
    {
      "type": 0,
      "value": "Add an activity"
    }
  ],
  "ActionTodoItem_activityRate": [
    {
      "type": 0,
      "value": "Rate "
    },
    {
      "type": 1,
      "value": "title"
    }
  ],
  "ActivityDiaryContex_itemPlural": [
    {
      "type": 0,
      "value": "Activities"
    }
  ],
  "ActivityDiaryContex_itemSingular": [
    {
      "type": 0,
      "value": "Activity"
    }
  ],
  "ActivityDiary_addActivityButton": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "ActivityDiary_graphAccessibilityLabel": [
    {
      "type": 0,
      "value": "A graph comparing mood ratings before and after "
    },
    {
      "type": 1,
      "value": "items"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "ActivityDiary_graphAfterLabel": [
    {
      "type": 0,
      "value": "After"
    }
  ],
  "ActivityDiary_graphBeforeLabel": [
    {
      "type": 0,
      "value": "Before"
    }
  ],
  "ActivityDiary_graphMonthScaleLabel": [
    {
      "type": 0,
      "value": "Month"
    }
  ],
  "ActivityDiary_graphWeekScaleLabel": [
    {
      "type": 0,
      "value": "Week"
    }
  ],
  "ActivityDiary_graphYAxisLabel": [
    {
      "type": 0,
      "value": "Mood Ratings"
    }
  ],
  "ActivityDiary_graphYearScaleLabel": [
    {
      "type": 0,
      "value": "Year"
    }
  ],
  "ActivityDiary_moodAfterLabel": [
    {
      "type": 0,
      "value": "Mood After"
    }
  ],
  "ActivityDiary_moodBeforeLabel": [
    {
      "type": 0,
      "value": "Mood Before"
    }
  ],
  "ActivityDiary_tableAddActivityLabel": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "type": 1,
      "value": "item"
    },
    {
      "type": 0,
      "value": " to get started"
    }
  ],
  "ActivityPractice_addToCalendarButton": [
    {
      "type": 0,
      "value": "Add to calendar"
    }
  ],
  "ActivityPractice_alreadyAddedToCalendar": [
    {
      "type": 0,
      "value": "Added to calendar"
    }
  ],
  "ActivityPractice_deleteButton": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "ActivityPractice_editButton": [
    {
      "type": 0,
      "value": "Edit"
    }
  ],
  "ActivityPractice_moodAfter": [
    {
      "type": 0,
      "value": "Mood after"
    }
  ],
  "ActivityPractice_moodBefore": [
    {
      "type": 0,
      "value": "Mood before"
    }
  ],
  "ActivityPractice_moodRatingsPrompt": [
    {
      "type": 0,
      "value": "What was your mood before and after this "
    },
    {
      "type": 1,
      "value": "item"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "ActivityPractice_notesLabel": [
    {
      "type": 0,
      "value": "Prepare"
    }
  ],
  "ActivityPractice_rateButton": [
    {
      "type": 0,
      "value": "Rate"
    }
  ],
  "ActivityPractice_unsavedChanges_cancelButton": [
    {
      "type": 0,
      "value": "No, don't"
    }
  ],
  "ActivityPractice_unsavedChanges_confirmButton": [
    {
      "type": 0,
      "value": "Yes, delete"
    }
  ],
  "ActivityPractice_unsavedChanges_description": [
    {
      "type": 0,
      "value": "Please confirm you'd like to delete this "
    },
    {
      "type": 1,
      "value": "item"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "ActivityPractice_unsavedChanges_title": [
    {
      "type": 0,
      "value": "Delete?"
    }
  ],
  "App_backButtonLabel": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "ArtifactButton_locked": [
    {
      "type": 0,
      "value": "Locked"
    }
  ],
  "AuthScreenContainer_logoLabel": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " Logo"
    }
  ],
  "AuthenticationError_emailExists": [
    {
      "type": 0,
      "value": "This email has already been taken."
    }
  ],
  "AuthenticationError_emailNotFound": [
    {
      "type": 0,
      "value": "This email + password is incorrect."
    }
  ],
  "AuthenticationError_invalidEmail": [
    {
      "type": 0,
      "value": "This email is not valid."
    }
  ],
  "AuthenticationError_invalidPassword": [
    {
      "type": 0,
      "value": "This email + password is incorrect."
    }
  ],
  "AuthenticationError_invalidPasswordNoEmail": [
    {
      "type": 0,
      "value": "This password is incorrect."
    }
  ],
  "AuthenticationError_missingEmail": [
    {
      "type": 0,
      "value": "This user does not exist."
    }
  ],
  "AuthenticationError_missingPassword": [
    {
      "type": 0,
      "value": "Please enter your password."
    }
  ],
  "AuthenticationError_tooManyAttempts": [
    {
      "type": 0,
      "value": "Too many failed login attempts. Try again in a few minutes."
    }
  ],
  "AuthenticationError_userDisabled": [
    {
      "type": 0,
      "value": "Your account has been disabled."
    }
  ],
  "AuthenticationError_userNotFound": [
    {
      "type": 0,
      "value": "Sorry, can't find that account."
    }
  ],
  "CalendarPicker_heading": [
    {
      "type": 0,
      "value": "Choose a calendar"
    }
  ],
  "CardStack_endAccessibilityLabel": [
    {
      "type": 0,
      "value": "End of cards"
    }
  ],
  "CardStack_flippableCard_flipButton": [
    {
      "type": 0,
      "value": "Flip"
    }
  ],
  "CardStack_indexAccessibilityLabel": [
    {
      "type": 0,
      "value": "Card "
    },
    {
      "type": 1,
      "value": "index"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "count"
    }
  ],
  "CardStack_nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "CardStack_nextButtonAccessibilityLabel": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "CardStack_nextCardAccessibilityLabel": [
    {
      "type": 0,
      "value": "Next card"
    }
  ],
  "CardStack_previousButtonAccessibilityLabel": [
    {
      "type": 0,
      "value": "Previous"
    }
  ],
  "CardStack_progress": [
    {
      "type": 1,
      "value": "index"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "count"
    }
  ],
  "Confidentiality_messageConfidential": [
    {
      "type": 0,
      "value": "Everything shared in this app is confidential."
    }
  ],
  "Confidentiality_messagePermissions": [
    {
      "type": 0,
      "value": "We will not share anything with others unless you give specific permission."
    }
  ],
  "Confidentiality_submitButton": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "Confidentiality_title": [
    {
      "type": 0,
      "value": "Confidential"
    }
  ],
  "ConfirmationModal_cancelButton": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "ConfirmationModal_closeButtonAccessibilityLabel": [
    {
      "type": 0,
      "value": "Close modal"
    }
  ],
  "ConfirmationModal_confirmButton": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "ContactsPicker_chooseButton": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "1 contact"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " contacts"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numContacts"
    }
  ],
  "ContactsPicker_searchPlaceholder": [
    {
      "type": 0,
      "value": "Search"
    }
  ],
  "ContactsPicker_title": [
    {
      "type": 0,
      "value": "Contacts"
    }
  ],
  "Conversation_chatTabText": [
    {
      "type": 0,
      "value": "Chat"
    }
  ],
  "Conversation_markSessionComplete": [
    {
      "type": 0,
      "value": "Mark session complete"
    }
  ],
  "Conversation_title": [
    {
      "type": 0,
      "value": "Conversation"
    }
  ],
  "Conversation_videoTabActivitiesHeadline": [
    {
      "type": 0,
      "value": "Activities"
    }
  ],
  "Conversation_videoTabText": [
    {
      "type": 0,
      "value": "Videos & activities"
    }
  ],
  "Conversation_videoTabVideosHeadline": [
    {
      "type": 0,
      "value": "Videos"
    }
  ],
  "DateTimeInput_cancelButton": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "DateTimeInput_confirmButton": [
    {
      "type": 0,
      "value": "Confirm"
    }
  ],
  "DateTimeInput_dateHeading": [
    {
      "type": 0,
      "value": "Pick a date"
    }
  ],
  "DateTimeInput_timeHeading": [
    {
      "type": 0,
      "value": "Pick a time"
    }
  ],
  "EatingCommitmentHealthyFood_fruits": [
    {
      "type": 0,
      "value": "Fruits"
    }
  ],
  "EatingCommitmentHealthyFood_grains": [
    {
      "type": 0,
      "value": "Grains"
    }
  ],
  "EatingCommitmentHealthyFood_healthyFats": [
    {
      "type": 0,
      "value": "Healthy fats (nuts, avocados, fish)"
    }
  ],
  "EatingCommitmentHealthyFood_leanMeats": [
    {
      "type": 0,
      "value": "Lean meats"
    }
  ],
  "EatingCommitmentHealthyFood_other": [
    {
      "type": 0,
      "value": "Other"
    }
  ],
  "EatingCommitmentHealthyFood_vegetables": [
    {
      "type": 0,
      "value": "Vegetables"
    }
  ],
  "EatingCommitmentUnhealthyFood_candy": [
    {
      "type": 0,
      "value": "Candy"
    }
  ],
  "EatingCommitmentUnhealthyFood_desserts": [
    {
      "type": 0,
      "value": "Desserts"
    }
  ],
  "EatingCommitmentUnhealthyFood_junkFood": [
    {
      "type": 0,
      "value": "Junk food"
    }
  ],
  "EatingCommitmentUnhealthyFood_other": [
    {
      "type": 0,
      "value": "Other"
    }
  ],
  "EatingCommitmentUnhealthyFood_soda": [
    {
      "type": 0,
      "value": "Soda"
    }
  ],
  "EatingCommitmentUnhealthyFood_takeout": [
    {
      "type": 0,
      "value": "Take out"
    }
  ],
  "EditActivityEvent_addHeader": [
    {
      "type": 0,
      "value": "Add "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "EditActivityEvent_attendeeAccessibilityLabel": [
    {
      "type": 0,
      "value": "Attendees"
    }
  ],
  "EditActivityEvent_attendeePlaceholder": [
    {
      "type": 0,
      "value": "Do "
    },
    {
      "type": 1,
      "value": "item"
    },
    {
      "type": 0,
      "value": " with"
    }
  ],
  "EditActivityEvent_cancelButton": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "EditActivityEvent_confirmationCancelButton": [
    {
      "type": 0,
      "value": "Discard"
    }
  ],
  "EditActivityEvent_confirmationConfirmButton": [
    {
      "type": 0,
      "value": "Save"
    }
  ],
  "EditActivityEvent_confirmationDescription": [
    {
      "type": 0,
      "value": "You've added info to this "
    },
    {
      "type": 1,
      "value": "item"
    },
    {
      "type": 0,
      "value": ". Would you like to save it before leaving?"
    }
  ],
  "EditActivityEvent_confirmationTitle": [
    {
      "type": 0,
      "value": "Save changes?"
    }
  ],
  "EditActivityEvent_durationPrepositionLabel": [
    {
      "type": 0,
      "value": "to"
    }
  ],
  "EditActivityEvent_editHeader": [
    {
      "type": 0,
      "value": "Edit "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "EditActivityEvent_endTimeAccessibilityLabel": [
    {
      "type": 0,
      "value": "End time"
    }
  ],
  "EditActivityEvent_endTimeValidationError": [
    {
      "type": 0,
      "value": "End time cannot be before start time"
    }
  ],
  "EditActivityEvent_locationAccessibilityLabel": [
    {
      "type": 0,
      "value": "Location"
    }
  ],
  "EditActivityEvent_locationPlaceholder": [
    {
      "type": 0,
      "value": "Activity location"
    }
  ],
  "EditActivityEvent_notesAccessibilityLabel": [
    {
      "type": 0,
      "value": "Notes"
    }
  ],
  "EditActivityEvent_notesPlaceholder": [
    {
      "type": 0,
      "value": "Things to prepare for "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "EditActivityEvent_optional": [
    {
      "type": 0,
      "value": "Optional"
    }
  ],
  "EditActivityEvent_saveButton": [
    {
      "type": 0,
      "value": "Save"
    }
  ],
  "EditActivityEvent_startDate": [
    {
      "type": 0,
      "value": "Date"
    }
  ],
  "EditActivityEvent_startTimeAccessibilityLabel": [
    {
      "type": 0,
      "value": "Start time"
    }
  ],
  "EditActivityEvent_titlePlaceholder": [
    {
      "type": 0,
      "value": "Name of "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "EditActivityPractice_editButton": [
    {
      "type": 0,
      "value": "Edit "
    },
    {
      "type": 1,
      "value": "item"
    }
  ],
  "EditActivityPractice_ratingAfterLabel": [
    {
      "type": 0,
      "value": "What was your mood after doing this?"
    }
  ],
  "EditActivityPractice_ratingBeforeLabel": [
    {
      "type": 0,
      "value": "What was your mood before doing this?"
    }
  ],
  "EditActivityPractice_saveButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "EditLessonsLearned_cancelButton": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "EditLessonsLearned_confirmationModal_cancelButton": [
    {
      "type": 0,
      "value": "Discard"
    }
  ],
  "EditLessonsLearned_confirmationModal_confirmButton": [
    {
      "type": 0,
      "value": "Save"
    }
  ],
  "EditLessonsLearned_confirmationModal_description": [
    {
      "type": 0,
      "value": "You’ve made changes. Would you like to save them before leaving?"
    }
  ],
  "EditLessonsLearned_confirmationModal_title": [
    {
      "type": 0,
      "value": "Save changes?"
    }
  ],
  "EditLessonsLearned_headerTitle": [
    {
      "type": 0,
      "value": "Edit lessons learned"
    }
  ],
  "EditLessonsLearned_saveButton": [
    {
      "type": 0,
      "value": "Save"
    }
  ],
  "EmailInput_label": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "ErrorPresenter_fieldErrorsHeading": [
    {
      "type": 0,
      "value": "**"
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "1 error"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " errors"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numErrors"
    },
    {
      "type": 0,
      "value": "** in the following fields:"
    }
  ],
  "FinishRegistering_phoneNumberLabel": [
    {
      "type": 0,
      "value": "Phone number"
    }
  ],
  "FinishRegistering_submitButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "FinishRegistering_title": [
    {
      "type": 0,
      "value": "Finish registering"
    }
  ],
  "Header_practiceButton": [
    {
      "type": 0,
      "value": "View Practice"
    }
  ],
  "Home_refreshIndicator": [
    {
      "type": 0,
      "value": "Update"
    }
  ],
  "Home_sessionProgress": [
    {
      "type": 1,
      "value": "completedCount"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "totalCount"
    }
  ],
  "Home_sessionsDone": [
    {
      "type": 0,
      "value": "Sessions done"
    }
  ],
  "Home_sessionsDoneAccessibilityLabel": [
    {
      "type": 0,
      "value": "Session progress: "
    },
    {
      "type": 1,
      "value": "completedCount"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalCount"
    },
    {
      "type": 0,
      "value": " complete"
    }
  ],
  "ImageInput_choosePhotoCameraOption": [
    {
      "type": 0,
      "value": "Take a photo"
    }
  ],
  "ImageInput_choosePhotoCancelOption": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "ImageInput_choosePhotoGalleryOption": [
    {
      "type": 0,
      "value": "Choose from gallery"
    }
  ],
  "LearnProgress_accessibilityLabel": [
    {
      "type": 0,
      "value": "Learn progress. "
    },
    {
      "type": 1,
      "value": "numCompleted"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "numTotal"
    },
    {
      "type": 0,
      "value": " completed"
    }
  ],
  "LearnProgress_progressText": [
    {
      "type": 1,
      "value": "numCompleted"
    },
    {
      "type": 0,
      "value": "/"
    },
    {
      "type": 1,
      "value": "numTotal"
    }
  ],
  "Learn_heading": [
    {
      "type": 0,
      "value": "Learn"
    }
  ],
  "Learn_refreshIndicator": [
    {
      "type": 0,
      "value": "Update"
    }
  ],
  "LocalAuthenticationPrompt_acceptButton": [
    {
      "type": 0,
      "value": "Yes, enable"
    }
  ],
  "LocalAuthenticationPrompt_biometricMethod": [
    {
      "type": 0,
      "value": "fingerprint or face unlock"
    }
  ],
  "LocalAuthenticationPrompt_denyButton": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "LocalAuthenticationPrompt_description": [
    {
      "type": 0,
      "value": "Use "
    },
    {
      "type": 1,
      "value": "method"
    },
    {
      "type": 0,
      "value": " to log in securely and easily. You can enable or disable it in your account settings at any time."
    }
  ],
  "LocalAuthenticationPrompt_faceMethod": [
    {
      "type": 0,
      "value": "FaceID"
    }
  ],
  "LocalAuthenticationPrompt_fingerprintMethod": [
    {
      "type": 0,
      "value": "Fingerprint"
    }
  ],
  "LocalAuthenticationPrompt_heading": [
    {
      "type": 0,
      "value": "Enable "
    },
    {
      "type": 1,
      "value": "method"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "LocalAuthenticationPrompt_irisMethod": [
    {
      "type": 0,
      "value": "Iris unlock"
    }
  ],
  "LocalAuthenticationPrompt_pinMethod": [
    {
      "type": 0,
      "value": "PIN"
    }
  ],
  "Login_description": [
    {
      "type": 0,
      "value": "You've been gone for a bit. For your privacy please re-enter your password."
    }
  ],
  "Login_emailLabel": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "Login_forgotPasswordButton": [
    {
      "type": 0,
      "value": "Forgot password?"
    }
  ],
  "Login_heading": [
    {
      "type": 0,
      "value": "Welcome back"
    }
  ],
  "Login_localAuthentication_biometricDescription": [
    {
      "type": 0,
      "value": "Use your fingerprint or face to login"
    }
  ],
  "Login_localAuthentication_biometricFailed": [
    {
      "type": 0,
      "value": "Not recognized"
    }
  ],
  "Login_localAuthentication_faceDescription": [
    {
      "type": 0,
      "value": "Use Face ID to login to app"
    }
  ],
  "Login_localAuthentication_faceFailed": [
    {
      "type": 0,
      "value": "Face not recognized"
    }
  ],
  "Login_localAuthentication_fingerprintDescription": [
    {
      "type": 0,
      "value": "Touch sensor to login to app"
    }
  ],
  "Login_localAuthentication_fingerprintFailed": [
    {
      "type": 0,
      "value": "Fingerprint not recognized"
    }
  ],
  "Login_localAuthentication_irisDescription": [
    {
      "type": 0,
      "value": "Use your irises to login"
    }
  ],
  "Login_localAuthentication_irisFailed": [
    {
      "type": 0,
      "value": "Not recognized"
    }
  ],
  "Login_localAuthentication_pinDescription": [
    {
      "type": 0,
      "value": "Enter PIN to login to app"
    }
  ],
  "Login_localAuthentication_pinFailed": [
    {
      "type": 0,
      "value": "The PIN is invalid"
    }
  ],
  "Login_localAuthentication_promptMessage": [
    {
      "type": 0,
      "value": "Login to app"
    }
  ],
  "Login_loginButton": [
    {
      "type": 0,
      "value": "Login"
    }
  ],
  "Login_logoutButton": [
    {
      "type": 0,
      "value": "Log out"
    }
  ],
  "Login_passwordLabel": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "Login_passwordPlaceholder": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "Login_passwordResetHint": [
    {
      "type": 0,
      "value": "Password reset successfully. Please log in."
    }
  ],
  "Login_reauthenticate_tryAgain": [
    {
      "type": 0,
      "value": "Try again"
    }
  ],
  "Login_reauthenticate_usePasswordButton": [
    {
      "type": 0,
      "value": "Type password"
    }
  ],
  "Login_reauthenticate_usePinButton": [
    {
      "type": 0,
      "value": "Login with PIN"
    }
  ],
  "Login_reauthenticate_usePinFallbackButton": [
    {
      "type": 0,
      "value": "Login with PIN"
    }
  ],
  "MinimumAppVersion_dismissButton": [
    {
      "type": 0,
      "value": "Not now"
    }
  ],
  "MinimumAppVersion_optionalUpgrade": [
    {
      "type": 0,
      "value": "There's a newer version of "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " that's available for download. Please update to continue using "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "MinimumAppVersion_requiredUpgrade": [
    {
      "type": 0,
      "value": "There's a newer version of "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " that's available for download. We recommend updating to ensure you have the best experience possible."
    }
  ],
  "MinimumAppVersion_title": [
    {
      "type": 0,
      "value": "Update Available"
    }
  ],
  "MinimumAppVersion_upgradeButton": [
    {
      "type": 0,
      "value": "Update"
    }
  ],
  "MultipleMediaLibrary_allMediaAlbumTitle": [
    {
      "type": 0,
      "value": "All media"
    }
  ],
  "PatientNotification_actionDescription_activityAdd": [
    {
      "type": 0,
      "value": "add an activity"
    }
  ],
  "PatientNotification_actionDescription_activityRate": [
    {
      "type": 0,
      "value": "rate an activity"
    }
  ],
  "PatientNotification_actionDescription_copingCardAdd": [
    {
      "type": 0,
      "value": "add a coping card"
    }
  ],
  "PatientNotification_actionDescription_copingCardReview": [
    {
      "type": 0,
      "value": "review your coping cards"
    }
  ],
  "PatientNotification_actionDescription_eatingLogAdd": [
    {
      "type": 0,
      "value": "add to your eating log"
    }
  ],
  "PatientNotification_actionDescription_hopeKitAdd": [
    {
      "type": 0,
      "value": "add to your "
    },
    {
      "type": 1,
      "value": "hopeKitName"
    }
  ],
  "PatientNotification_actionDescription_hopeKitReview": [
    {
      "type": 0,
      "value": "review your "
    },
    {
      "type": 1,
      "value": "hopeKitName"
    }
  ],
  "PatientNotification_actionDescription_myPlanReview": [
    {
      "type": 0,
      "value": "review MyPlan"
    }
  ],
  "PatientNotification_actionDescription_relax": [
    {
      "type": 0,
      "value": "do a relaxation exercise"
    }
  ],
  "PatientNotification_actionDescription_sleepDiaryMorning": [
    {
      "type": 0,
      "value": "complete your morning Sleep Diary"
    }
  ],
  "PatientNotification_actionDescription_sleepDiaryNight": [
    {
      "type": 0,
      "value": "complete your night Sleep Diary"
    }
  ],
  "PatientNotification_actionDescription_thoughtDiarySpot": [
    {
      "type": 0,
      "value": "spot a new thought"
    }
  ],
  "PatientNotification_actionDescription_thoughtDiarySwitch": [
    {
      "type": 0,
      "value": "switch a thought"
    }
  ],
  "PatientNotification_actionDescription_thoughtDiaryTest": [
    {
      "type": 0,
      "value": "test a thought"
    }
  ],
  "PatientSupporterRelation_clinician": [
    {
      "type": 0,
      "value": "Clinician"
    }
  ],
  "PatientSupporterRelation_other": [
    {
      "type": 0,
      "value": "Other"
    }
  ],
  "PatientSupporterRelation_parentGuardian": [
    {
      "type": 0,
      "value": "Parent/guardian"
    }
  ],
  "PatientSupporterRelation_relative": [
    {
      "type": 0,
      "value": "Relative"
    }
  ],
  "PatientSupporterRelation_socialServices": [
    {
      "type": 0,
      "value": "Social services"
    }
  ],
  "PracticeRating_label_1": [
    {
      "type": 0,
      "value": "Awful"
    }
  ],
  "PracticeRating_label_2": [
    {
      "type": 0,
      "value": "Bad"
    }
  ],
  "PracticeRating_label_3": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "PracticeRating_label_4": [
    {
      "type": 0,
      "value": "Good"
    }
  ],
  "PracticeRating_label_5": [
    {
      "type": 0,
      "value": "Great"
    }
  ],
  "PracticeTile_activityDiary_description": [
    {
      "type": 0,
      "value": "Do activities to lift your mood"
    }
  ],
  "PracticeTile_activityDiary_title": [
    {
      "type": 0,
      "value": "Activity diary"
    }
  ],
  "PracticeTile_locked": [
    {
      "type": 0,
      "value": "locked"
    }
  ],
  "PracticeTile_lockedUntilHint": [
    {
      "type": 0,
      "value": "Finish session "
    },
    {
      "type": 1,
      "value": "sessionNum"
    }
  ],
  "PracticeTile_practiceCount": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " done"
    }
  ],
  "Practices_xAxisMonthLabel": [
    {
      "type": 0,
      "value": "Week beginning"
    }
  ],
  "Practices_xAxisWeekLabel": [
    {
      "type": 0,
      "value": "Days"
    }
  ],
  "Practices_xAxisYearLabel": [
    {
      "type": 0,
      "value": "Months"
    }
  ],
  "Profile_choosePhotoCameraOption": [
    {
      "type": 0,
      "value": "Take a photo"
    }
  ],
  "Profile_choosePhotoCancelOption": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "Profile_choosePhotoGalleryOption": [
    {
      "type": 0,
      "value": "Choose from gallery"
    }
  ],
  "Profile_profilePhotoButton": [
    {
      "type": 0,
      "value": "Profile photo"
    }
  ],
  "Profile_settingsButton": [
    {
      "type": 0,
      "value": "Settings"
    }
  ],
  "ReauthenticationModal_submitButton": [
    {
      "type": 0,
      "value": "Submit"
    }
  ],
  "RequestResetPassword_description": [
    {
      "type": 0,
      "value": "Don't worry. Resetting your password is easy. Just tell us the email address you registered with "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "RequestResetPassword_emailLabel": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "RequestResetPassword_error": [
    {
      "type": 0,
      "value": "Something went wrong requesting a password reset email. Please make sure you've entered your email address properly."
    }
  ],
  "RequestResetPassword_heading": [
    {
      "type": 0,
      "value": "Forgot your password?"
    }
  ],
  "RequestResetPassword_submitButton": [
    {
      "type": 0,
      "value": "Request password reset"
    }
  ],
  "RequestResetPassword_success": [
    {
      "type": 0,
      "value": "Please check your email to reset your password."
    }
  ],
  "RequestResetPassword_title": [
    {
      "type": 0,
      "value": "Forgot password"
    }
  ],
  "ResetPassword_description": [
    {
      "type": 0,
      "value": "You're almost there. Enter a new password to update your account."
    }
  ],
  "ResetPassword_error": [
    {
      "type": 0,
      "value": "We couldn't reset your password. Your token may have expired. Please request a new reset password email."
    }
  ],
  "ResetPassword_heading": [
    {
      "type": 0,
      "value": "Choose a new password"
    }
  ],
  "ResetPassword_passwordConfirmationLabel": [
    {
      "type": 0,
      "value": "Confirm password"
    }
  ],
  "ResetPassword_passwordHint": [
    {
      "type": 0,
      "value": "Must be at least 8 characters"
    }
  ],
  "ResetPassword_passwordLabel": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "ResetPassword_passwordMismatchError": [
    {
      "type": 0,
      "value": "Your password and password confirmation do not match"
    }
  ],
  "ResetPassword_requestNewEmailButton": [
    {
      "type": 0,
      "value": "Request another email"
    }
  ],
  "ResetPassword_submitButton": [
    {
      "type": 0,
      "value": "Set password"
    }
  ],
  "ResetPassword_title": [
    {
      "type": 0,
      "value": "Reset password"
    }
  ],
  "ReviewCompleteCard_complete": [
    {
      "type": 0,
      "value": "Review complete"
    }
  ],
  "ReviewCompleteCard_doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "ReviewCompleteCard_resetButton": [
    {
      "type": 0,
      "value": "Reset cards"
    }
  ],
  "Signup_confirmPasswordLabel": [
    {
      "type": 0,
      "value": "Confirm password"
    }
  ],
  "Signup_confirmPasswordPlaceholder": [
    {
      "type": 0,
      "value": "Confirm password"
    }
  ],
  "Signup_emailLabel": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "Signup_loginButton": [
    {
      "type": 0,
      "value": "Login"
    }
  ],
  "Signup_passwordHint": [
    {
      "type": 0,
      "value": "Must be at least 8 characters"
    }
  ],
  "Signup_passwordLabel": [
    {
      "type": 0,
      "value": "Set a password"
    }
  ],
  "Signup_passwordPlaceholder": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "Signup_termsOfService": [
    {
      "type": 0,
      "value": "By creating an account you agree to the "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Terms of Service & Privacy Policy"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "Signup_title": [
    {
      "type": 0,
      "value": "Create your account"
    }
  ],
  "SwitchInput_offLabel": [
    {
      "type": 0,
      "value": "Off"
    }
  ],
  "SwitchInput_onLabel": [
    {
      "type": 0,
      "value": "On"
    }
  ],
  "Tabs_homeTab": [
    {
      "type": 0,
      "value": "Home"
    }
  ],
  "Tabs_learnTab": [
    {
      "type": 0,
      "value": "Learn"
    }
  ],
  "Tabs_practiceTab": [
    {
      "type": 0,
      "value": "Practice"
    }
  ],
  "Tabs_profileTab": [
    {
      "type": 0,
      "value": "Profile"
    }
  ],
  "Tabs_tabAccessibilityLabel": [
    {
      "type": 1,
      "value": "tabName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "TreatmentList_avivaSupport_activityPlanning_subtitle": [
    {
      "type": 0,
      "value": "Do activities to feel better"
    }
  ],
  "TreatmentList_avivaSupport_activityPlanning_title": [
    {
      "type": 0,
      "value": "Getting going"
    }
  ],
  "TreatmentList_avivaSupport_copingCards_subtitle": [
    {
      "type": 0,
      "value": "Create reminder flash cards"
    }
  ],
  "TreatmentList_avivaSupport_copingCards_title": [
    {
      "type": 0,
      "value": "Coping cards"
    }
  ],
  "TreatmentList_avivaSupport_hopeKit_subtitle": [
    {
      "type": 0,
      "value": "Create a reminder of your hopes"
    }
  ],
  "TreatmentList_avivaSupport_hopeKit_title": [
    {
      "type": 0,
      "value": "Hope kit"
    }
  ],
  "TreatmentList_avivaSupport_howToHelp_subtitle": [
    {
      "type": 0,
      "value": "How to help"
    }
  ],
  "TreatmentList_avivaSupport_howToHelp_title": [
    {
      "type": 0,
      "value": "Introduction"
    }
  ],
  "TreatmentList_avivaSupport_myPlanReview_subtitle": [
    {
      "type": 0,
      "value": "Tie learnings together"
    }
  ],
  "TreatmentList_avivaSupport_myPlanReview_title": [
    {
      "type": 0,
      "value": "Risk curve & MyPlan"
    }
  ],
  "TreatmentList_avivaSupport_myPlan_subtitle": [
    {
      "type": 0,
      "value": "Make a plan to stay safe"
    }
  ],
  "TreatmentList_avivaSupport_myPlan_title": [
    {
      "type": 0,
      "value": "MyPlan"
    }
  ],
  "TreatmentList_avivaSupport_postAviva_subtitle": [
    {
      "type": 0,
      "value": "How Aviva can keep helping you"
    }
  ],
  "TreatmentList_avivaSupport_postAviva_title": [
    {
      "type": 0,
      "value": "What's next?"
    }
  ],
  "TreatmentList_avivaSupport_reduceRisk_subtitle": [
    {
      "type": 0,
      "value": "Review skills you learned"
    }
  ],
  "TreatmentList_avivaSupport_reduceRisk_title": [
    {
      "type": 0,
      "value": "Skills to reduce risk"
    }
  ],
  "TreatmentList_avivaSupport_relaxation_subtitle": [
    {
      "type": 0,
      "value": "Learn calming exercises"
    }
  ],
  "TreatmentList_avivaSupport_relaxation_title": [
    {
      "type": 0,
      "value": "Relaxation & mindfulness"
    }
  ],
  "TreatmentList_avivaSupport_sleep_subtitle": [
    {
      "type": 0,
      "value": "Develop better sleep habits"
    }
  ],
  "TreatmentList_avivaSupport_sleep_title": [
    {
      "type": 0,
      "value": "Improving sleep"
    }
  ],
  "TreatmentList_avivaSupport_spotIt_subtitle": [
    {
      "type": 0,
      "value": "Link thoughts to how you feel"
    }
  ],
  "TreatmentList_avivaSupport_spotIt_title": [
    {
      "type": 0,
      "value": "Spot it"
    }
  ],
  "TreatmentList_avivaSupport_switchIt_subtitle": [
    {
      "type": 0,
      "value": "Find more helpful thoughts"
    }
  ],
  "TreatmentList_avivaSupport_switchIt_title": [
    {
      "type": 0,
      "value": "Switch it"
    }
  ],
  "TreatmentList_avivaSupport_testIt_subtitle": [
    {
      "type": 0,
      "value": "Challenge your thoughts"
    }
  ],
  "TreatmentList_avivaSupport_testIt_title": [
    {
      "type": 0,
      "value": "Test it"
    }
  ],
  "TreatmentList_aviva_activityPlanning_description": [
    {
      "type": 0,
      "value": "What’s it mean to get going\nLink doing activities to mood\nRecord activities and mood"
    }
  ],
  "TreatmentList_aviva_activityPlanning_subtitle": [
    {
      "type": 0,
      "value": "Do activities to feel better"
    }
  ],
  "TreatmentList_aviva_activityPlanning_title": [
    {
      "type": 0,
      "value": "Getting going"
    }
  ],
  "TreatmentList_aviva_copingCards_description": [
    {
      "type": 0,
      "value": "Remember your skills learned\nHow to create Coping cards\nMake time to practice them"
    }
  ],
  "TreatmentList_aviva_copingCards_subtitle": [
    {
      "type": 0,
      "value": "Create reminder flash cards"
    }
  ],
  "TreatmentList_aviva_copingCards_title": [
    {
      "type": 0,
      "value": "Coping cards"
    }
  ],
  "TreatmentList_aviva_hopeKit_description": [
    {
      "type": 0,
      "value": "What is a Hope Kit & why it’s helpful\nStart building your kit\nMake time to use it"
    }
  ],
  "TreatmentList_aviva_hopeKit_subtitle": [
    {
      "type": 0,
      "value": "Create a reminder of your hopes"
    }
  ],
  "TreatmentList_aviva_hopeKit_title": [
    {
      "type": 0,
      "value": "Hope kit"
    }
  ],
  "TreatmentList_aviva_myPlanReview_description": [
    {
      "type": 0,
      "value": "Reviewing your risk curve\nReviewing MyPlan\nMake updates to MyPlan"
    }
  ],
  "TreatmentList_aviva_myPlanReview_subtitle": [
    {
      "type": 0,
      "value": "Tie learnings together"
    }
  ],
  "TreatmentList_aviva_myPlanReview_title": [
    {
      "type": 0,
      "value": "Risk curve & MyPlan"
    }
  ],
  "TreatmentList_aviva_myPlan_description": [
    {
      "type": 0,
      "value": "How suicide risk rises and falls\nPlot your own risk curve\nCreate a plan to stay safe"
    }
  ],
  "TreatmentList_aviva_myPlan_subtitle": [
    {
      "type": 0,
      "value": "Make a plan to stay safe"
    }
  ],
  "TreatmentList_aviva_myPlan_title": [
    {
      "type": 0,
      "value": "MyPlan"
    }
  ],
  "TreatmentList_aviva_postAviva_description": [
    {
      "type": 0,
      "value": "What happens now\nSeeking more help\nContinue using Aviva"
    }
  ],
  "TreatmentList_aviva_postAviva_subtitle": [
    {
      "type": 0,
      "value": "How Aviva can keep helping you"
    }
  ],
  "TreatmentList_aviva_postAviva_title": [
    {
      "type": 0,
      "value": "What's next?"
    }
  ],
  "TreatmentList_aviva_reduceRisk_description": [
    {
      "type": 0,
      "value": "Skills to change behaviors\nSkills to change thoughts\nWhat was most helpful"
    }
  ],
  "TreatmentList_aviva_reduceRisk_subtitle": [
    {
      "type": 0,
      "value": "Review skills you learned"
    }
  ],
  "TreatmentList_aviva_reduceRisk_title": [
    {
      "type": 0,
      "value": "Skills to reduce risk"
    }
  ],
  "TreatmentList_aviva_relaxation_description": [
    {
      "type": 0,
      "value": "What are relaxation skills\nHow to use them\nMake time to practice"
    }
  ],
  "TreatmentList_aviva_relaxation_subtitle": [
    {
      "type": 0,
      "value": "Learn calming exercises"
    }
  ],
  "TreatmentList_aviva_relaxation_title": [
    {
      "type": 0,
      "value": "Relaxation & mindfulness"
    }
  ],
  "TreatmentList_aviva_sleep_description": [
    {
      "type": 0,
      "value": "Why is sleeping well important\nWhat might disrupt your sleep\nTrack your sleep habits"
    }
  ],
  "TreatmentList_aviva_sleep_subtitle": [
    {
      "type": 0,
      "value": "Develop better sleep habits"
    }
  ],
  "TreatmentList_aviva_sleep_title": [
    {
      "type": 0,
      "value": "Improving sleep"
    }
  ],
  "TreatmentList_aviva_spotIt_description": [
    {
      "type": 0,
      "value": "Why thoughts affect feelings\nHow to spot negative thoughts\nWrite spotted thoughts"
    }
  ],
  "TreatmentList_aviva_spotIt_subtitle": [
    {
      "type": 0,
      "value": "Link thoughts to how you feel"
    }
  ],
  "TreatmentList_aviva_spotIt_title": [
    {
      "type": 0,
      "value": "Spot it"
    }
  ],
  "TreatmentList_aviva_switchIt_description": [
    {
      "type": 0,
      "value": "Why balance your thoughts\nHow to switch it\nWrite switched thoughts"
    }
  ],
  "TreatmentList_aviva_switchIt_subtitle": [
    {
      "type": 0,
      "value": "Find more helpful thoughts"
    }
  ],
  "TreatmentList_aviva_switchIt_title": [
    {
      "type": 0,
      "value": "Switch it"
    }
  ],
  "TreatmentList_aviva_testIt_description": [
    {
      "type": 0,
      "value": "Why test your thoughts\nHow to test negative thoughts\nWrite evidence for & against"
    }
  ],
  "TreatmentList_aviva_testIt_subtitle": [
    {
      "type": 0,
      "value": "Challenge your thoughts"
    }
  ],
  "TreatmentList_aviva_testIt_title": [
    {
      "type": 0,
      "value": "Test it"
    }
  ],
  "Welcome_navigateToLogin": [
    {
      "type": 0,
      "value": "I already have an account"
    }
  ],
  "Welcome_title": [
    {
      "type": 0,
      "value": "Hi there"
    }
  ],
  "patientSocialSupporterRelation_CHEERLEADER": [
    {
      "type": 0,
      "value": "Cheerleader"
    }
  ],
  "patientSocialSupporterRelation_DETRACTOR": [
    {
      "type": 0,
      "value": "Detractor"
    }
  ],
  "patientSocialSupporterRelation_PARTNER": [
    {
      "type": 0,
      "value": "Partner"
    }
  ],
  "patientSocialSupporterRelation_POSITIVE_ENABLER": [
    {
      "type": 0,
      "value": "Positive Enabler"
    }
  ]
}